<template>
    <div class="as-statics">
        <div class="as-statics-item as__title">
            <div>Thống kê</div>
            <div>Thắng %</div>
            <div>Trung bình</div>
            <div>Đã ghi bàn</div>
            <div>Bị thủng lưới</div>
            <div>BTTS</div>
            <div>Giữ sạch lưới</div>
            <div>FTS</div>
            <div>xG</div>
            <div>xG chống lại</div>
        </div>
        <div class="as-statics-item as__overview">
            <div>Tổng quan</div>
            <div>
                {{ getValueWithMode(teamMode, 'winPercentage_overall') }}%
            </div>
            <div>
                {{ getValueWithMode(teamMode, 'seasonAVG_overall') }}
            </div>
            <div>
                {{ getValueWithMode(teamMode, 'seasonScoredAVG_overall') }}
            </div>
            <div>
                {{ getValueWithMode(teamMode, 'seasonConcededAVG_overall') }}
            </div>
            <div>
                {{ getValueWithMode(teamMode, 'seasonBTTSPercentage_overall') }}%
            </div>
            <div>
                {{ getValueWithMode(teamMode, 'seasonCSPercentage_overall') }}%
            </div>
            <div>
                {{ getValueWithMode(teamMode, 'seasonFTSPercentage_overall') }}%
            </div>
            <div>
                {{ getValueWithMode(teamMode, 'xg_for_avg_overall') }}
            </div>
            <div>
                {{ getValueWithMode(teamMode, 'xg_against_avg_overall') }}
            </div>
        </div>
        <div class="as-statics-item as__home">
            <div>Đội nhà</div>
            <div>
                {{ getValueWithMode(teamMode, 'winPercentage_home') }}%
            </div>
            <div>
                {{ getValueWithMode(teamMode, 'seasonAVG_home') }}
            </div>
            <div>
                {{ getValueWithMode(teamMode, 'seasonScoredAVG_home') }}
            </div>
            <div>
                {{ getValueWithMode(teamMode, 'seasonConcededAVG_home') }}
            </div>
            <div>
                {{ getValueWithMode(teamMode, 'seasonBTTSPercentage_home') }}%
            </div>
            <div>
                {{ getValueWithMode(teamMode, 'seasonCSPercentage_home') }}%
            </div>
            <div>
                {{ getValueWithMode(teamMode, 'seasonFTSPercentageHT_home') }}%
            </div>
            <div>
                {{ getValueWithMode(teamMode, 'xg_for_avg_home') }}
            </div>
            <div>
                {{ getValueWithMode(teamMode, 'xg_against_avg_home') }}
            </div>
        </div>
        <div class="as-statics-item as__away">
            <div>Đội khách</div>
            <div>
                {{ getValueWithMode(teamMode, 'winPercentage_away') }}%
            </div>
            <div>
                {{ getValueWithMode(teamMode, 'seasonAVG_away') }}
            </div>
            <div>
                {{ getValueWithMode(teamMode, 'seasonScoredAVG_away') }}
            </div>
            <div>
                {{ getValueWithMode(teamMode, 'seasonConcededAVG_away') }}
            </div>
            <div>
                {{ getValueWithMode(teamMode, 'seasonBTTSPercentage_away') }}%
            </div>
            <div>
                {{ getValueWithMode(teamMode, 'seasonCSPercentage_away') }}%
            </div>
            <div>
                {{ getValueWithMode(teamMode, 'seasonFTSPercentageHT_away') }}%
            </div>
            <div>
                {{ getValueWithMode(teamMode, 'xg_for_avg_away') }}
            </div>
            <div>
                {{ getValueWithMode(teamMode, 'xg_against_avg_away') }}
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    import { computed } from 'vue';
    import type { IFootyStats, ITeam, IStatsParent } from '~src/interfaces/footystats';

    interface Props {
        footyStats: IFootyStats | null;
        teamMode?: string
        homeTeamInfo: ITeam | null;
        awayTeamInfo: ITeam | null;
    }

    const props = withDefaults(defineProps<Props>(), {
        teamMode: 'home',
        footyStats: null
    })

    const homeTeamLastX = computed<IStatsParent>(() => {
        return props.footyStats?.home_team_last_x ?? ({} as IStatsParent);
    });

    const awayTeamLastX = computed<IStatsParent>(() => {
        return props.footyStats?.away_team_last_x ?? ({} as IStatsParent);
    });

    const getValueWithMode = (team = 'home', mode = 'btts') => {
        const __data: IStatsParent = team === "home" ? homeTeamLastX.value : awayTeamLastX.value;

        let __mode = mode
        if (!__data || !__data.stats || !__data.stats.hasOwnProperty(__mode)) {
            return 0;
        }

        return __data.stats[__mode];
    }
</script>

<script lang="ts">
export default {};
</script>
